import { Injectable } from '@angular/core';
import { AppConfig } from '../../app-config.module';
import { Observable } from 'rxjs';
import { ApiClient } from 'src/app/infrastructure/api-client/api-client';
import { ErrorLogRequest } from 'src/app/model/api/api-request/error-log-request';
import { AppConfigService } from '../app-config.service';

@Injectable()
export class LogService
{
    private readonly apiClient: ApiClient;
    private readonly appConfig: AppConfig;

    public constructor(apiClient: ApiClient, appConfig: AppConfig, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
        this.appConfig = appConfig;
    }

    public info<T>(message: string): void
    {
        console.log(this.appConfig, message);
    }

    public error<T>(category: string, error: Error = new Error('unknown'), userAgent: string = ''): Observable<void>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new ErrorLogRequest(category || '', error.message || '', error.stack || '', userAgent, webapiBasepath);
        return this.apiClient.post(request);
    }

    public warn<T>(message: string): void
    {
        console.warn(this.appConfig, message);
    }

    public debug(message: string): void
    {
        if (!this.appConfig.production)
        {
            console.debug(this.appConfig, message);
        }
    }
}
